export const normalizeSteps = (data) => {
    // v2.0 format: JSON may use 'steps' OR 'codeSteps' — normalize to both.
    const v2Source = data?.codeSteps || (data?.version === '2.0' ? data?.steps : null)
    if (v2Source) {
        const sorted = [...v2Source].sort(
            (a, b) => (a.stepNumber || 0) - (b.stepNumber || 0)
        )
        return {
            ...data,
            codeSteps: sorted,
            steps: sorted,
        }
    }

    // v1.0 legacy format: uses steps (full state snapshots)
    const rawSteps = Array.isArray(data?.steps) ? data.steps : []
    const steps = rawSteps.sort((a, b) => (a.id || 0) - (b.id || 0))

    const totalSteps = Number(data?.totalSteps || steps.length || 0) || 0

    return {
        ...data,
        steps,
        totalSteps,
    }
}

export const fetchHexSteps = async (
    apiProjectId,
    isPreview = undefined,
    screenId
) => {
    if (!apiProjectId) {
        throw new Error('apiProjectId is required to fetch hex steps')
    }

    const BACKEND_URL = process.env.REACT_APP_API_BASE

    // Determine preview mode; allow callers to override
    const isPreviewMode =
        typeof isPreview === 'boolean'
            ? isPreview
            : new URLSearchParams(window.location.search).get('preview') ===
              'true'

    console.log(
        'Fetching hex steps for project:',
        apiProjectId,
        'screenId:',
        screenId,
        'Preview mode:',
        isPreviewMode
    )

    // Build the endpoint based on the mode, include screenId if available
    const basePath = isPreviewMode
        ? `${BACKEND_URL}/api/staging/hex/${apiProjectId}`
        : `${BACKEND_URL}/api/hex/${apiProjectId}`
    const endpoint = screenId ? `${basePath}/${screenId}` : basePath

    const response = isPreviewMode ? await fetch(endpoint, { credentials: 'include' }) : await fetch(endpoint)

    if (!response.ok) {
        throw new Error(`Hex steps request failed: ${response.status}`)
    }

    const data = await response.json()
    console.log('Normalized data:', normalizeSteps(data))
    return normalizeSteps(data)
}
